import { type PreloadedState, configureStore } from '@reduxjs/toolkit';

import { UNIQUE_CONFIG_KEY } from '@/app/shared/constants/config';

import { type TReduxActions, type TReduxState, type TReduxStore } from '../types';

import { rootReducer } from './rootReducer';

export function getReduxStore(preloadedState: PreloadedState<TReduxState> | undefined, devTools: boolean): TReduxStore {
  return configureStore<TReduxState, TReduxActions>({
    devTools: devTools && { name: UNIQUE_CONFIG_KEY },
    preloadedState,
    reducer: rootReducer,
  });
}
